var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"breadcrumbs"},[_c('div',{staticClass:"container"},[_c('b-breadcrumb',{staticClass:"pb-10",attrs:{"items":_vm.items}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }